import type { ReactNode } from "react";

import { useHasAnyPermission, useHasPermission } from "@/lib/permissions";

type Props =
  | { perm: string; anyOf?: never; children: ReactNode; fallback?: ReactNode }
  | { perm?: never; anyOf: readonly string[]; children: ReactNode; fallback?: ReactNode };

/** Conditionally render `children` only when the user has the required
 * permission(s). UI hiding only — server-side `HasOrgPermission` is the
 * authoritative gate. */
export function PermissionGate(props: Props) {
  const single = useHasPermission(props.perm ?? "__none__");
  const anyOf = useHasAnyPermission(props.anyOf ?? []);
  const ok = props.perm ? single : anyOf;
  if (!ok) return <>{props.fallback ?? null}</>;
  return <>{props.children}</>;
}